import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityTitleHeader, SiteHeaderLayout, SiteHeaderProvider, useEntity } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
import { DOING_DEEP_BLUE, DOING_SUNSHINE, PRIMARY_LIGHT } from '../../theme';

const cls = classNames('page-layout-knowledge-hub');

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
};

export const PageLayoutKnowledgeHub: PageLayoutComponent = 
(props) => {
  const { className, slices, children } = props;
  const entity = useEntity(props.entity);

  return (
    <SiteHeaderProvider value={{
      variant: 'default', // setting variant to overlay keeps the login utility button icon and text white...
      
    }}>
      <My.Container className={cls.name(className)}>
      <SiteHeaderLayout />
      {slices}
      </My.Container>
    </SiteHeaderProvider>
  )
};